
export default {
  name: "TableMoneyField",
  props: {
    model: [Number, String],
  },
};
